import React, { ReactElement, SyntheticEvent, useEffect, useState } from 'react'
import ScheduleHandler from '../../../Database/handlers/ScheduleHandler'
import useLocalStorage from '../../../hooks/useLocalStorage'
import { ITodoSchedule, schedule, TodoObj } from '../../../types/interfaces'
import CreateCalendarData from '../../../Utilities/CreateCalendarData'
import TodosSchedule from '../TodosSchedule/TodosSchedule'
import CalendarCell from './CalendarCell/CalendarCell'
import "./ScheduleCalendar.css"
interface Props{
  schedules:ITodoSchedule[]
}
export default function ScheduleCalender({schedules}:Props) {
  const scheduleHandler = new ScheduleHandler()
  const [project,setProject] = useLocalStorage("project",null)
  const [state, setstate] = useState<{
    DateElements: ReactElement[],
    currentMonthName: string,
    currentYear: number,
    currentMonthIndex:number,
    schedulesArr: ITodoSchedule[]
  }>({
    currentMonthName: new Date().toLocaleString("en-us", { month: "long" }) || "",
    currentMonthIndex: new Date().getMonth(),
    currentYear: new Date().getFullYear() || 0,
    DateElements: [],
    schedulesArr:schedules
  })
  useEffect(() => {
    scheduleHandler.FetchSchedules(project.ProjectName).then(() => {
        const elements = CreateCalendar(new Date().getMonth(), new Date().getFullYear())
      setstate({
        currentMonthName: state.currentMonthName,
        currentMonthIndex: state.currentMonthIndex,
        currentYear: state.currentYear,
        DateElements: elements,
        schedulesArr:schedules
      })
    })
  }, [schedules])
  
  
  function CreateCalendar(month: number, year: number) {
    let elements:ReactElement[] = []
    let rowElements: ReactElement[] = []

    const Calendarelements = CreateCalendarData(month, year,schedules)
    let iterator = 0
    
    while (Calendarelements[0][iterator].id == "None") {
      const date = Calendarelements[0][iterator]
      rowElements.push(
        <CalendarCell todosArr={date.todos} key={date.id + iterator}
          id={date.id}>{date.content}
        </CalendarCell>)
      iterator++
    }
    Calendarelements.forEach((row,i) => {
      row.forEach((date) => {
        if (date.id != "None"){
          rowElements.push(
            
            <CalendarCell todosArr={date.todos} key={date.id} id={date.id}>
              <p>{date.content}</p>
            </CalendarCell>)
        
        }
        
      })
      elements.push(<tr key={`${i}`} className='Calender-Dates'>{rowElements}</tr>)
      rowElements = []
    })
    return elements
    
  }


  function SetYear(event: SyntheticEvent) {
    const EventBtn = event.target as HTMLButtonElement
    let ResultYear = 0;
    switch (EventBtn.id) {
      case 'Prev-Year-Btn':
        ResultYear = state.currentYear - 1
        break;
      case 'Next-Year-Btn':
        ResultYear = state.currentYear + 1
        break;
      default:
        break;
    }
    const elements = CreateCalendar(state.currentMonthIndex,ResultYear)
    setstate({
      currentYear: ResultYear,
      currentMonthName: state.currentMonthName,
      currentMonthIndex: state.currentMonthIndex,
      DateElements: elements,
      schedulesArr:schedules
    })
  }
  function SetMonth(event: SyntheticEvent) {
    const EventBtn = event.target as HTMLButtonElement
    let ResultMonthIndex = 0
    let ResultMonthName = ""
    switch (EventBtn.id) {
      case 'Prev-Month-Btn':
        ResultMonthIndex = state.currentMonthIndex <= 0 ? 11:state.currentMonthIndex - 1
        ResultMonthName = new Date(state.currentYear,ResultMonthIndex).toLocaleString("en-us", { month: "long" })
        break;
      case 'Next-Month-Btn':
        ResultMonthIndex = state.currentMonthIndex >= 11 ?0:state.currentMonthIndex + 1
        ResultMonthName = new Date(state.currentYear,ResultMonthIndex).toLocaleString("en-us", { month: "long" })
        break;
      default:
        break;
    }
    const elements = CreateCalendar(ResultMonthIndex,state.currentYear)
    setstate({
      currentYear: state.currentYear,
      currentMonthName: ResultMonthName,
      currentMonthIndex: ResultMonthIndex,
      DateElements: elements,
      schedulesArr:schedules
    })
      
  }
  return (
    <>
    <table className='Calender-Container'>
      <thead>
        <tr className='Calender-Year'>
        <td><button id='Prev-Year-Btn' onClick={SetYear}>◀</button></td>
        <td colSpan={5}>{state.currentYear}</td>
        <td><button id='Next-Year-Btn' onClick={SetYear}>▶</button></td>
      </tr>
      <tr className='Calender-Month'>
        <td><button id='Prev-Month-Btn' onClick={SetMonth}>◀</button></td>
        <td colSpan={5}>{state.currentMonthName}</td>
        <td><button id='Next-Month-Btn' onClick={SetMonth}>▶</button></td>
      </tr>
      <tr className='Calender-WeekDays'>
        <td>Sun</td>
        <td>Mon</td>
        <td>Tue</td>
        <td>Wed</td>
        <td>Thu</td>
        <td>Fri</td>
        <td>Sat</td>
      </tr>
      </thead>
      <tbody>{state.DateElements}</tbody>
      
      </table>
      
    </>
  )
}
